import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../../common/types';
import { PITCH_STEPS, type PitchProgress } from './pitchProgress';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the People list and the details panel */
import styles from './People.module.scss';
/* eslint-enable css-modules/no-unused-class */

const STEPS = Array.from({ length: PITCH_STEPS }, (_, index) => index);

/**
 * The four steps of a pitch as a short bar (design outreach-v2 t1): sent, opened, listened 30 s+,
 * replied or added. A planned pitch shows a dashed first step.
 */
const PitchTrackComponent: React.FC<{ progress: PitchProgress; planned?: boolean }> = ({ progress, planned }) => (
  <span className={styles.track} aria-hidden>
    {STEPS.map((step) => (
      <i
        key={step}
        className={clsx(
          styles.trackStep,
          step < progress.reached && styles[`trackOn-${progress.tone}`],
          planned === true && step === 0 && styles.trackWait
        )}
      />
    ))}
  </span>
);

export const PitchTrack = TypedMemo(PitchTrackComponent);
